import { HorizontalAlignment } from "@mcleod/core";
import { AutogenLayoutIntellirouteCityList } from "./autogen/AutogenLayoutIntellirouteCityList";
import { Table, TableColumn } from "@mcleod/components";

export class IntellirouteCityList extends AutogenLayoutIntellirouteCityList {

    override onLoad() {
        const tableCity: Table = this.tableCity;
        const cityCodeColumn = tableCity.getColumnByCaption("Intelliroute City Code") as TableColumn;
        if (cityCodeColumn && cityCodeColumn.headingCell) {
            cityCodeColumn.headingCell.align = HorizontalAlignment.LEFT;
        }
    }
}
